
import { Options } from "vue-class-component";
import { FormGroup } from "../../../model/FormGroup.model";
import { minPlayer, maxPlayer } from "../../../services/validators";
import BaseForm from "../../baseForm/baseForm.vue";
@Options({})
export default class NumberPlayer extends BaseForm {
  public numberPlayer = 10;

  public formGroup: FormGroup = {
    numberPlayer: {
      rules: [minPlayer(10), maxPlayer(1000)],
      value: this.numberPlayer
    }
  };
}
